import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  statusColor: {
    borderRadius: "50%",
    display: "inline-block",
    height: "13px",
    width: "13px",
    border: "2px solid",
    borderColor: theme.palette.borderColor,
  },
  statusName: {
    margin: "0px 14px",
    fontSize: "10px",
    [theme.breakpoints.down("lg")]: {
      fontSize: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "14px",
    },
  },
}));

export default useStyles;